import React, { useState } from 'react'
import { Box, Tab, Tabs, useMediaQuery, useTheme } from '@mui/material'

import { ProductList } from './ProductList'

// The tabbed shell mirrors the customer detail layout so this section reads the
// same way. Products is the only tab today (YAR-14850); further configuration
// views slot in here without touching the route or the sidebar.
const tabs = [{ label: 'Products', panel: <ProductList /> }]

export const Products: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [value, setValue] = useState(0)

  const handleChange = (_: React.SyntheticEvent, newValue: number) => setValue(newValue)

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Products Tabs"
          textColor="secondary"
          TabIndicatorProps={{ sx: { backgroundColor: '#4C4CFF' } }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={tab.label}
              label={tab.label}
              id={`products-tab-${index}`}
              aria-controls={`products-tabpanel-${index}`}
              sx={{
                minWidth: 100,
                px: isMobile ? 1 : 2,
                fontSize: isMobile ? '0.85rem' : '1rem',
                textTransform: 'capitalize',
                color: value === index ? '#4C4CFF' : theme.palette.text.secondary,
                '&:hover': { color: '#4C4CFF' },
              }}
            />
          ))}
        </Tabs>
      </Box>

      {tabs.map((tab, index) => (
        <Box
          key={tab.label}
          role="tabpanel"
          hidden={value !== index}
          id={`products-tabpanel-${index}`}
          aria-labelledby={`products-tab-${index}`}
        >
          {value === index && tab.panel}
        </Box>
      ))}
    </Box>
  )
}
